import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CommonVariablesService } from '../../common-variables.service';
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-insuring-clause-mapper',
  templateUrl: './insuring-clause-mapper.component.html',
  styleUrls: ['./insuring-clause-mapper.component.css']
})
export class InsuringClauseMapperComponent implements OnInit {
  insuringClausesMapperForm: FormGroup;
  insuringClausesMapperFormValue: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  submitted = false;
  btnAddShow = false;
  btnUpdateShow = true;
  dropdownSettings: IDropdownSettings = {};
  coverageDropdown: any;
  conveyanceDropdown: any;
  MopVoyageNameArr: any;
  StopVoyageNameArr: any;
  MopDataArr: any;
  StopDataArr: any;
  voyageNameDropdown: any;
  subVoyageNameDropdown: any;
  url: any;
  tblData: any;
  insuringClauseMapperId: any;
  isDisable = false;
  isViewMode: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit() {
    this.url = this.commonVariablesService['baseURL'] + 'api/v1/marine_master/';
	window.localStorage.setItem('pageName','');
    this.insuringClausesMapperForm = this.formBuilder.group({
      /* selPolicyType: ['', Validators.required], */
      selVoyageName: ['', Validators.required],
      selSubVoyageName: ['', Validators.required],
      selCoverage: ['', Validators.required],
      selConveyance: ['', Validators.required],
      txtInsuringClause: ['', Validators.required],
      selLogic: ['', Validators.required]
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'name',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem('userProfile');
    const getUserType = this.commonService.decryptData(tmpUserType);
    this.isViewMode = ((getUserType || '').toLowerCase() == 'adminview');

    await this.loadPolicyTypeMop();
    /* this.loadPolicyTypeStop(); */
    await this.loadCoverageType();
    await this.loadCoveyance();
    await this.loadInsuringClauseMapper();
	
  }

  /*******************************************
  * Created By : Dinesh kumar
  * Description : Used to get form controls.
  ********************************************/
  get f() { return this.insuringClausesMapperForm.controls; }

  /*************************************************************
  * Created By : Dinesh kumar
  * Description : Used to get voyage & sub voyage name for MOP.
  **************************************************************/
  async loadPolicyTypeMop() {
    let fetchMopUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/voyage/all';
    let MOPData = await this.commonService.httpGetMethod(fetchMopUrl, '', true, '', 'Insuring Clauses Mapper');
    this.MopVoyageNameArr = [];
    this.MopDataArr = [];
    let tmpVoyage = new Set();
    let tmpData = new Set();
	
    if (MOPData.status == 0) {
      for (let count of MOPData.data) {
        tmpVoyage.add(count.voyage_name);
        tmpData.add(count.voyage_name + "|" + count.sub_voyage_name);
      }
      this.MopVoyageNameArr = tmpVoyage;
      this.MopDataArr = tmpData;
	  this.voyageNameDropdown = this.MopVoyageNameArr;
    }
    else if (MOPData.status != -114) {
      // this.commonService.errorsmsg('Fetch Error', 'Error');
    }
  }

  /*************************************************************
  * Created By : Dinesh kumar
  * Description : Used to get voyage & sub voyage name for STOP.
  **************************************************************/
  async loadPolicyTypeStop() {
    let fetchStopUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/voyage/STOP';
    let STOPData = await this.commonService.httpGetMethod(fetchStopUrl, '', true, '', 'Insuring Clauses Mapper');
    this.StopVoyageNameArr = [];
    this.StopDataArr = [];
    let tmpVoyage = new Set();
    let tmpData = new Set();

    if (STOPData.status == 0) {
      for (let count of STOPData.data) {
        tmpVoyage.add(count.voyage_name);
        tmpData.add(count.voyage_name + "|" + count.sub_voyage_name);
      }
      this.StopVoyageNameArr = tmpVoyage;
      this.StopDataArr = tmpData;
    }
    else if (STOPData.status != -114) {
      // this.commonService.errorsmsg('Fetch Error', 'Error');
    }
  }

  /******************************************
  * Created By : Dinesh kumar
  * Description : Used to get covergae type.
  ******************************************/
  async loadCoverageType() {
    let fetchCoverageUrl = this.commonVariablesService.baseURL + 'api/v1/master/marine_m_coverage_type';
    let fetchCoverageData = await this.commonService.httpGetMethod(fetchCoverageUrl, '', true, '', 'Insuring Clauses Mapper');
    this.coverageDropdown = [];

    if (fetchCoverageData.status == 0) {
      for (let count of fetchCoverageData.data) {
        this.coverageDropdown.push(count.name);
      }
    }
    else if (fetchCoverageData.status != -114) {
      // this.commonService.errorsmsg('Fetch Error', 'Error');
    }
  }

  /**********************************************
  * Created By : Dinesh kumar
  * Description : Used to get mode of conveyance.
  ***********************************************/
  async loadCoveyance() {
    let fetchCoveyanceUrl = this.commonVariablesService.baseURL + 'api/v1/master/marine_m_mode_of_conveyance';
    let fetchCoveyanceData = await this.commonService.httpGetMethod(fetchCoveyanceUrl, '', true, '', 'Insuring Clauses Mapper');
    this.conveyanceDropdown = [];

    if (fetchCoveyanceData.status == 0) {
      for (let count of fetchCoveyanceData.data) {
        this.conveyanceDropdown.push(count.name);
      }
    }
    else if (fetchCoveyanceData.status != -114) {
      // this.commonService.errorsmsg('Fetch Error', 'Error');
    }
  }

  /*************************************************************************************
  * Created By : Dinesh kumar
  * Description : Used to get selected policy type & load voyage name against the type.
  **************************************************************************************/
 /*  selectedPolicyType(type) {
    this.insuringClausesMapperForm.patchValue({
      selVoyageName: '',
      selSubVoyageName: ''
    });
    this.voyageNameDropdown = [];
    this.subVoyageNameDropdown = [];

    if (type == 'MOP')
      this.voyageNameDropdown = this.MopVoyageNameArr;
    else if (type == 'STOP')
      this.voyageNameDropdown = this.StopVoyageNameArr;
  } */

  /****************************************************************************************
  * Created By : Dinesh kumar
  * Description : Used to get selected policy type & load sub voyage name against the type.
  ******************************************************************************************/
  loadSubVoyageTypeList(selectedVoyageName) {
    this.insuringClausesMapperForm.patchValue({
      selSubVoyageName: ''
    });
    this.subVoyageNameDropdown = [];

    /* if (this.insuringClausesMapperForm.value.selPolicyType == "MOP") { */

      for (let count of this.MopDataArr) {
        let tmpVoyage = count.split("|");

        if (tmpVoyage[0] == selectedVoyageName) {
			let array = tmpVoyage[1].split(',')
			for(let i =0;i<array.length;i++)
				this.subVoyageNameDropdown.push(array[i]);
        }
      }
    /* } */
    /* else if (this.insuringClausesMapperForm.value.selPolicyType == "STOP") {

      for (let count of this.StopDataArr) {
        let tmpVoyage = count.split("|");

        if (tmpVoyage[0] == selectedVoyageName) {
          this.subVoyageNameDropdown.push(tmpVoyage[1]);
        }
      }
    } */
  }

  /************************************************************
  * Created By : Dinesh kumar
  * Description : Used to fetch existing data for this master.
  *************************************************************/
  async loadInsuringClauseMapper() {
    $("#searchVoyageName, #searchSubVoyageName, #searchCoverage, #searchConveyance, #searchInsuringClause, #searchLogic, #searchUpdatedBy, #searchUpdatedTime").val('');
    let table = $('#insuringClauseDatatable').DataTable();
    table.destroy();
    this.tblData = [];
    let fetchUrl = this.url + 'fetchall/insuring_clause_mapper';
    let fetchData = await this.commonService.httpGetMethod(fetchUrl, '', true, '', 'Insuring Clauses Mapper');

    if (fetchData.status == 0) {
      let len = fetchData.data.length;
      for (let count = 0; count < len; count++) {
		  fetchData.data[count].u_ts = this.datePipe.transform(new Date(fetchData.data[count].u_ts+" GMT").toISOString(),"dd-MM-yyyy HH:mm:ss")
        this.tblData.push(fetchData.data[count]);
      }
    }
    else if (fetchData.status != -114) {
      this.commonService.errorsmsg('Fetch Error', 'Error');
    }
    this.dtTrigger.next();
  }

  /*****************************************************************
  * Created By : Dinesh kumar
  * Description : Used to add new entry for insuring clauses mapper.
  ******************************************************************/
  async addInsuringClauseMapper() {
     
    let ret: any = await this.checkInsuringClauseData();
    if (ret.status != 0) return;

    let param = new HttpParams()
      .set('policy_type', this.insuringClausesMapperFormValue.selPolicyType)
      .set('voyage_name', this.insuringClausesMapperFormValue.selVoyageName)
      .set('sub_voyage_name', this.insuringClausesMapperFormValue.selSubVoyageName)
      .set('coverage_type', this.insuringClausesMapperFormValue.selCoverage)
      .set('mode_of_conveyance', ret.data.mode_of_conveyance)
      .set('insuring_clause', (this.insuringClausesMapperFormValue.txtInsuringClause).trim())
      .set('logic', ret.data.logic);
    let addUrl = this.url + 'add/insuring_clause_mapper';
    let addResponse = await this.commonService.httpPostMethod(addUrl, param, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Insuring Clauses Mapper');

    if (addResponse.body.status == 0) {
      this.commonService.successmsg('Insuring clause mapper data added successfully', 'Success');
      await this.loadInsuringClauseMapper();
      this.resetForm();
    }
    else {
      if (addResponse.body.status != -114) {
        let tmp = (addResponse.body.data).split(' ');

        if (tmp[0] == 'Duplicate')
          this.commonService.errorsmsg('Policy Type & Voyage Name & Sub Voyage Name & Coverage Type & Mode of Conveyance already exist', 'Error');
        else
          this.commonService.errorsmsg('Unable to add insuring clause mapper data', 'Error');
      }
    }
  }

  /*****************************************************
  * Created By : Dinesh kumar
  * Description : Used to prefill all the fields in UI.
  ******************************************************/
  editInsuringClauseMapper(oldResponse) {
    /* this.insuringClausesMapperForm.patchValue({
      selPolicyType: oldResponse.policy_type
    }); */
	
    this.btnAddShow = true;
    this.btnUpdateShow = false;
    /* $('#selPolicyType').attr('disabled', 'true'); */
    $('#selVoyageName').attr('disabled', 'true');
    $('#selSubVoyageName').attr('disabled', 'true');
    $('#selCoverage').attr('disabled', 'true');
    // $('#selConveyance').attr('disabled', 'true');
    this.isDisable = true;
    /* this.selectedPolicyType(oldResponse.policy_type); */
    this.loadSubVoyageTypeList(oldResponse.voyage_name);

    var txtLogic = '', conveyanceArr = [];
    conveyanceArr = (oldResponse.mode_of_conveyance).split(', ');

    if (oldResponse.logic == '1')
      txtLogic = 'All';
    else
      txtLogic = 'Any One';
    this.insuringClausesMapperForm.patchValue({
      // selPolicyType: oldResponse.policy_type,
      selVoyageName: oldResponse.voyage_name,
      selSubVoyageName: oldResponse.sub_voyage_name,
      selCoverage: oldResponse.coverage_type,
      selConveyance: conveyanceArr,
      txtInsuringClause: oldResponse.insuring_clause_and_condition,
      selLogic: txtLogic
    });
    this.insuringClauseMapperId = oldResponse.clause_id;
  }

  /**************************************************************************
  * Created By : Dinesh kumar
  * Description : Used to update existing entry for insuring clauses mapper.
  ***************************************************************************/
  async updateInsuringClauseMapper() {
    
    let ret: any = await this.checkInsuringClauseData();
    if (ret.status != 0) return;

    let updateParam = new HttpParams()
      /* .set('policy_type', this.insuringClausesMapperFormValue.selPolicyType) */
      .set('voyage_name', this.insuringClausesMapperFormValue.selVoyageName)
      .set('sub_voyage_name', this.insuringClausesMapperFormValue.selSubVoyageName)
      .set('coverage_type', this.insuringClausesMapperFormValue.selCoverage)
      .set('mode_of_conveyance', ret.data.mode_of_conveyance)
      .set('insuring_clause', (this.insuringClausesMapperFormValue.txtInsuringClause).trim())
      .set('logic', ret.data.logic)
      .set('id', this.insuringClauseMapperId);
    let updateUrl = this.url + 'update/insuring_clause_mapper';
    let response = await this.commonService.httpPostMethod(updateUrl, updateParam, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Insuring Clauses Mapper');

    if (response.body.status == 0) {
      this.commonService.successmsg('Insuring clause mapper data updated successfully', 'Success');
      await this.loadInsuringClauseMapper();
      this.resetForm();
    }
    else {
      if (response.body.status != -114) {
        let tmp = (response.body.data).split(' ');

        if (tmp[0] == 'Duplicate')
          this.commonService.errorsmsg('Policy Type & Voyage Name & Sub Voyage Name & Coverage Type & Mode of Conveyance already exist', 'Error');
        else
          this.commonService.errorsmsg('Unable to update insuring clause mapper data', 'Error');
      }
    }
  }

  /**************************************************************************
  * Created By : Dinesh kumar
  * Description : Used to delete existing entry for insuring clauses mapper.
  ***************************************************************************/
  async deleteInsuringClauseMapper(oldResponse) {
    let status = await this.commonService.deleteAlertMsg();

    if (status) {
      this.spinner.show();
      let deleteUrl = this.url + 'delete/insuring_clause_mapper/' + oldResponse.clause_id;
      let response = await this.commonService.httpPostMethod(deleteUrl, '', 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Insuring Clauses Mapper');

      if (response.body.status == 0) {
        this.commonService.warningmsg('Insuring clause mapper data deleted successfully', 'Warning');
        await this.loadInsuringClauseMapper();
        this.resetForm();
      }
      else if (response.body.status != -114) {
        this.commonService.errorsmsg('Unable to delete Insuring clause mapper data', 'Error');
      }
    }
  }

  /**************************************
  * Created By : Dinesh kumar
  * Description : Used to reset the form.
  ***************************************/
  resetForm() {
    this.insuringClausesMapperForm.reset();
    this.submitted = false;
    this.isDisable = false;
    this.btnAddShow = false;
    this.btnUpdateShow = true;
    /* $('#selPolicyType').removeAttr('disabled'); */
    $('#selVoyageName').removeAttr('disabled');
    $('#selSubVoyageName').removeAttr('disabled');
    $('#selCoverage').removeAttr('disabled');
    // $('#selConveyance').removeAttr('disabled');
    /* this.voyageNameDropdown = []; */
    this.subVoyageNameDropdown = [];
    //todo:selConveyance:  '',
    this.insuringClausesMapperForm.patchValue({
      /* selPolicyType: '', */
      selVoyageName: '',
      selSubVoyageName: '',
      selCoverage: '',
      // selConveyance:  '',
      txtInsuringClause: '',
      selLogic: ''
    });
  }

  /***********************************************
  * Created By : Dinesh kumar
  * Description : Used to do search in datatable.
  ************************************************/
  filterBySearch() {
    /* let searchPolicyType = $("#searchPolicyType").val().toString().toLowerCase(); */
    let searchVoyageName = $("#searchVoyageName").val().toString().toLowerCase();
    let searchSubVoyageName = $("#searchSubVoyageName").val().toString().toLowerCase();
    let searchCoverage = $("#searchCoverage").val().toString().toLowerCase();
    let searchConveyance = $("#searchConveyance").val().toString().toLowerCase();
    let searchInsuringClause = $("#searchInsuringClause").val().toString().toLowerCase();
    let searchLogic = $("#searchLogic").val().toString().toLowerCase();
    let searchUpdatedBy = $("#searchUpdatedBy").val().toString().toLowerCase();
    let searchUpdatedTime = $("#searchUpdatedTime").val().toString().toLowerCase();
    var table = $("#insuringClauseDatatable").DataTable();
    table.search('').columns().search('').draw();

    /* if (searchPolicyType != "") {
      table.column(0).search(searchPolicyType).draw();
    } */
    if (searchVoyageName != "") {
      table.column(0).search(searchVoyageName).draw();
    }
    if (searchSubVoyageName != "") {
      table.column(1).search(searchSubVoyageName).draw();
    }
    if (searchCoverage != "") {
      table.column(2).search(searchCoverage).draw();
    }
    if (searchConveyance != "") {
      table.column(3).search(searchConveyance).draw();
    }
    if (searchInsuringClause != "") {
      table.column(4).search(searchInsuringClause).draw();
    }
    if (searchLogic != "") {
      table.column(5).search(searchLogic).draw();
    }
    if (searchUpdatedBy != "") {
      table.column(6).search(searchUpdatedBy).draw();
    }
    if (searchUpdatedTime != "") {
      table.column(7).search(searchUpdatedTime).draw();
    }
  }
  exportExcel()
	{
	   var tmpArray=[];
	   var tmpObj={};
	   
	   if(this.tblData.length>0)
	   {
		 for(var i=0;i<this.tblData.length;i++)
		 {
		  tmpObj={};
			/* tmpObj['policy_type']=this.tblData[i].policy_type; */
			tmpObj['voyage_name']=this.tblData[i].voyage_name;
			tmpObj['sub_voyage_name']=this.tblData[i].sub_voyage_name;
			tmpObj['coverage_type']=this.tblData[i].coverage_type;
			tmpObj['mode_of_conveyance']=this.tblData[i].mode_of_conveyance;
			tmpObj['insuring_clause_and_condition']=this.tblData[i].insuring_clause_and_condition;
			tmpObj['logic']=this.tblData[i].logic;
			tmpObj['author']=this.tblData[i].author;
			tmpObj['u_ts']=this.tblData[i].u_ts;
			tmpArray.push(tmpObj)
		 }
		 var datajson= { datajson1: tmpArray };

		 var Heading = [
		   [],
		   ["Insuring Clause Mapper"],
		   [],
		   ["Voyage Name","Sub Voyage Name","Coverage Type","Mode of Conveyance","Insuring Clauses and Conditions","Logic","Updated By","Updated Time"]
		 ];

		 const merge = [
			 { s: { r: 0, c: 0 }, e: { r: 0, c: 9 } },
			 { s: { r: 1, c: 0 }, e: { r: 1, c: 9 } },
			 { s: { r: 2, c: 0 }, e: { r: 2, c: 9 } },
			 /* { s: { r: 3, c: 0 }, e: { r: 3, c: 3 } }, */
		 ];
		 
		 var wscols = [];
		 //let cell;
		 for (let idx = 0; idx < Heading[3].length; idx++) 
		 {
			 wscols.push({ wch: 25 });  // Common column width
		 }
		 var ws = XLSX.utils.json_to_sheet(Heading);
		 ws['!cols'] = wscols;
		 ws["!merges"] = merge;
		 ws["A1"] = {
			 "t": 's',
			 /* "v": 'TATA MARINE', */
			 "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center"} }
		 };
		 XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
			 /* header: ["group_name","author","u_ts"], */
			 skipHeader: true,
			 origin: -1
		 });
		 // var alphabets = [''];
		 var wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Insuring Clause Mapper");
		 XLSX.writeFile(wb, 'Insuring_Clause_Mapper.xlsx');
	   }
	   else
	   {
		this.commonService.errorsmsg("Unable to download excel,No data available in the table","Error"); 
	   }
   }

   /*
   * Created By : Sharann
   * Description : check the data before add/update.
   ***********************************************/
   checkInsuringClauseData() {
    return new Promise(resolve => {
      this.insuringClausesMapperFormValue = this.insuringClausesMapperForm.value;
      if (this.insuringClausesMapperForm.invalid) {
        this.submitted = true;
        return resolve({ status: -1, data: {} });
      }
      if ((this.insuringClausesMapperFormValue.txtInsuringClause).trim() == '') {
        this.commonService.errorsmsg('Missing Insuring clauses and condition', 'Error');
      }
      else {
        this.spinner.show();
        var txtLogic = '', conveyanceStr = '';
  
        if (this.insuringClausesMapperFormValue.selLogic == 'All')
          txtLogic = '1';
        else
          txtLogic = '2';
  
        for (let count of this.insuringClausesMapperFormValue.selConveyance) {
          conveyanceStr += count + ', ';
        }
        conveyanceStr = conveyanceStr.substring(0, conveyanceStr.length - 2);
      }
  
      return resolve({ status: 0, data: { logic: txtLogic, mode_of_conveyance: conveyanceStr } });
    });
  }

}
